import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Icon from '@material-ui/core/Icon'
const styles = theme => ({
  container: {
    height: 'calc(100%)'
  },
  paperIcon: {
    borderRadius: '50%',
    width: 50,
    height: 50
  },
  icon: {
    fontSize: '50px'
  },
  progress: {
    margin: `0 ${theme.spacing.unit * 2}px`
  }
})

export default withStyles(styles)(
  class RightVerificationComponent extends React.Component {
    static propTypes = {
      classes: PropTypes.object,
      email: PropTypes.string.isRequired,
      hiboutikAccount: PropTypes.string.isRequired,
      accountVerified: PropTypes.bool,
      checkAccountCreation: PropTypes.func.isRequired
    }
    static defaultProps = {
      accountVerified: false
    }
    handleVerifyClick = e => {
      this.props.checkAccountCreation(this.props.hiboutikAccount)
    }
    renderSuccess() {
      const { classes } = this.props
      return (
        <Grid
          item
          container
          direction="column"
          justify="center"
          alignItems="center"
          spacing={24}>
          <Grid
            container
            alignItems="center"
            justify="center"
            item
            xs={10}
            spacing={0}>
            <Paper className={classes.paperIcon} elevation={4}>
              <Icon color="primary" className={classes.icon}>
                check
              </Icon>
            </Paper>
          </Grid>
          <Grid
            container
            alignItems="center"
            justify="center"
            item
            xs={10}
            spacing={0}>
            <Typography variant="headline">Le compte est Validé</Typography>
          </Grid>
        </Grid>
      )
    }
    render() {
      const { classes, email, accountVerified } = this.props
      if (accountVerified) {
        return this.renderSuccess()
      }
      return (
        <Grid
          item
          container
          direction="row"
          justify="center"
          alignItems="center"
          alignContent="space-between"
          spacing={24}>
          <Grid
            container
            alignItems="center"
            justify="center"
            item
            xs={10}
            spacing={0}>
            <Typography variant="headline" align="center" gutterBottom>
              En attente de validation de votre compte hiboutik...
            </Typography>
          </Grid>
          <Grid
            container
            alignItems="center"
            justify="center"
            item
            xs={10}
            spacing={0}>
            <CircularProgress
              className={classes.progress}
              color="secondary"
              size={30}
            />
          </Grid>
          <Grid
            container
            alignItems="center"
            justify="center"
            item
            xs={10}
            spacing={0}>
            <Typography variant="subheading" align="center" gutterBottom>
              Vérifiez votre boîte de réception ({email})
            </Typography>
          </Grid>
          <Grid
            container
            alignItems="center"
            justify="center"
            item
            xs={10}
            spacing={0}>
            <Button
              disabled={accountVerified}
              color="primary"
              variant="raised"
              onClick={this.handleVerifyClick}>
              J'ai vérifié mon compte Hiboutik
            </Button>
          </Grid>
        </Grid>
      )
      // return
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/HiboutikAccountCreation/RightVerificationComponent.js